import styled from 'styled-components';

export const TableHeaderRow = styled.tr`
  display: table-row !important;
  border: 0 !important;
`;
